import React from 'react';

import { H3Text, H4Text } from '@prisjakt/ui/text/variants';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Column, Row } from '@prisjakt/ui/list/variants';
import { Spinner } from 'src/components/spinner';

import { ThankYouWrapper, FeedbackPrompt, SubmitButton } from './styles';

import { useFeedback } from 'src/hooks/use-feedback';

type Props = {
  closeModal: () => void;
};

export const ThankYouScreen = (props: Props) => {
  const { closeModal } = props;

  const { t } = useAppContext();
  const { loadState, loadFeedback } = useFeedback();

  return (
    <ThankYouWrapper>
      <Column gap={1}>
        <H3Text>{t('feedback', 'uup.completed-title')}</H3Text>
        <H4Text>
          {t('feedback', 'uup.completed-description')}{' '}
          <FeedbackPrompt type="button" onClick={loadFeedback}>
            <Row gap={0.5}>
              {t('feedback', 'uup.completed-feedback-prompt')}{' '}
              {loadState === 'loading' && (
                <Spinner
                  position="none"
                  size={16}
                  isActive={loadState === 'loading'}
                />
              )}
            </Row>
          </FeedbackPrompt>
        </H4Text>

        <SubmitButton onClick={closeModal}>
          {t('symbols', 'symbol.close')}
        </SubmitButton>
      </Column>
    </ThankYouWrapper>
  );
};
